
export default {
    props: {
        method: Function
    },
    data() {
        return {
            activeLayerButtonIndex: 0,
            visibleMap: ''
        }
    },
    computed: {
        settings() {
            return this.$store.getters.getSettings
        }
    },
    created() {
        this.visibleMap = this.settings.achtergrondkaarten[0].naam
    },
    methods: {
        setMap(layer) {

            this.visibleMap = layer

            // Houd de pijltjesnavigatie gelijk met de laag die daadwerkelijk aan staat,
            // zodat de focus na een klik verder loopt vanaf de actieve knop.
            const activeIndex = this.settings.achtergrondkaarten.findIndex(
                (backgroundLayer) => backgroundLayer.naam === layer
            )

            if(activeIndex > -1) {
                this.activeLayerButtonIndex = activeIndex
            }

            this.method(layer)
        },
        clickKey(event) {

            // Alleen de pijltjestoetsen verplaatsen de focus binnen de groep.
            // Bij elke andere toets meteen stoppen: anders trekt focus() hieronder
            // de focus terug naar deze knoppen en kun je met Tab niet meer uit de
            // groep weg (de focus blijft dan hangen op de laatste knop).
            const goLeft = event.key === 'ArrowLeft' || event.keyCode === 37
            const goRight = event.key === 'ArrowRight' || event.keyCode === 39

            if(!goLeft && !goRight) {
                return
            }

            const layerButtons = this.$refs['layer-button'] || []
            const step = goLeft ? -1 : 1

            // Knoppen die via v-show verborgen zijn kunnen geen focus krijgen: overslaan.
            let activeLayerButtonIndex = this.activeLayerButtonIndex + step

            while(activeLayerButtonIndex >= 0
                && activeLayerButtonIndex < layerButtons.length
                && layerButtons[activeLayerButtonIndex].offsetParent === null) {
                activeLayerButtonIndex = activeLayerButtonIndex + step
            }

            if(activeLayerButtonIndex < 0 || activeLayerButtonIndex >= layerButtons.length) {
                return
            }

            // Voorkomt dat de kaart tegelijk meepant en de pagina scrollt.
            event.preventDefault()

            layerButtons[activeLayerButtonIndex].focus()
            layerButtons[activeLayerButtonIndex].checked = true // radio-variant (Nijmegen)
            this.activeLayerButtonIndex = activeLayerButtonIndex
        },
        btnShowBackgroundLayer(layer) {

            let showBackgroundLayer = true;


            const layers = [];
            let selectedIndex = 0;
            this.settings.achtergrondkaarten.map( (value, index) => {
                if(value.naam === layer.naam) {
                    layers.push(layer);
                }
                if(value.id === layer.id) {
                    selectedIndex = index;
                }
            });

            if(layers.length > 1 && selectedIndex === 0) {
                showBackgroundLayer = false;
            }

            return showBackgroundLayer;
        }
    }
}
